import {
  IntegrationType,
  Provider,
  ProviderType,
} from 'domains/models/account/providerType';
import { z } from 'zod';

export const ProviderTypeEnum = z.nativeEnum(ProviderType);
export const ProviderEnum = z.nativeEnum(Provider);
export const IntegrationTypeEnum = z.nativeEnum(IntegrationType);
